import React from 'react'

export default function Myyntivinkit() {
    return (
        <div className="myyntivinkit row py-3 border">
            <div className="col-lg-1"></div>
            <div className="m-auto col-12 col-lg-10">
                <div className="vinkitkuva">
                    <div className="row ">
                        <h1 className="pb-4 mt-4 text-center fontti">Myyntivinkkejä</h1>

                        <div className="col-sm-6 text-center p-0 ps-sm-4 ps-lg-5">
                        <div className="px-4">
                            <p className="pb-2"><span className="fas fa-bullseye"></span> Myy puhdasta ja ehjää tavaraa ja vaatetta</p>
                            <p className="pb-2"><span className="fas fa-bullseye"></span> Huomioi sesonki</p>
                            <p className="pb-2"><span className="fas fa-bullseye"></span> Merkitse selkeästi tuote, hinta ja koko</p>
                            <p className="pb-2"><span className="fas fa-bullseye"></span> Muista kirppishinnat</p>
                            <p className=""><span className="fas fa-bullseye"></span> Vauvan vaatteet on kätevintä myydä koreissa ja merkitä koot</p>
                            </div>
                        </div>

                        <div className="col-sm-6 pb-4 text-center p-0 pe-sm-4 pe-lg-5">
                            <div className="palkit px-4">
                                <p className="pb-2"><span className="fas fa-bullseye"></span> Täytä pöytää maltillisesti, lisää tavaraa vähitellen</p>
                                <p className="pb-2"><span className="fas fa-bullseye"></span> Herätä huomio esim. äitiysvaatteita, ISOJA KOKOJA jne.</p>
                                <p className="pb-2"><span className="fas fa-bullseye"></span> Oman pöydän mainostaminen on sallittua <span className="far fa-smile-wink"></span></p>
                                <p className="pb-2"><span className="fas fa-bullseye"></span> Tee myyntipaikasta houkutteleva ja käytä siistejä koreja ja pusseja</p>
                                <p className=""><span className="fas fa-bullseye"></span> TÄRKEIN KAIKISTA: SIISTI PÖYTÄ MYY <span className="far fa-smile"></span></p>
                            </div>
                            
                        </div>
                    </div>
                    
                </div>
                
            </div>
            <div className="col-lg-1"></div>
            
        </div>
    )
}
